import { useCallback, useEffect, useState } from 'react';
import { Communication } from 'types';

import { getCommunication } from '../api/getCommunication';

type UseGetCommunicationProps = {
  communicationId?: string;
};

export const useGetCommunication = ({
  communicationId,
}: UseGetCommunicationProps) => {
  const [communication, setCommunication] = useState<Communication | null>(
    null
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchCommunication = useCallback(
    async (controller: AbortController) => {
      if (!communicationId) return;

      try {
        setIsLoading(true);

        const responseCommunication = (await getCommunication({
          communicationId,
          signal: controller.signal,
        })) as Communication;

        if (!controller.signal.aborted) {
          setCommunication(responseCommunication);
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    [communicationId]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchCommunication(controller);

    return () => controller.abort();
  }, [fetchCommunication]);

  return {
    data: { communication },
    isLoading,
    isError,
  };
};
